import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { getColor } from '../../../utils/ColorUtil'
import { i18nize } from '../../../utils/StringUtil'
import { EVENT_TYPES } from '../../constants/EventsConstants'
import { Box, Grid2 } from '@mui/material'

const EventsTypeLegendPanel = ({ eventsTypes }) => {
    return (
        <Grid2 container size={12} spacing={0.5}>
            {
                (eventsTypes || i18nize(EVENT_TYPES)).concat([{ label: i18n.unknownType, color: 'GREY' }]).map((eventType, i) => (
                    <Grid2 key={i} container size={6} spacing={1} alignItems={'center'}>
                        <Grid2 container size={12}>
                            <Box
                                sx={{
                                    padding: '0 15px',
                                    borderRadius: 10,
                                    backgroundColor: getColor(eventType.color),
                                }}
                            />
                            <Grid2>{ eventType.label }</Grid2>
                        </Grid2>
                    </Grid2>
                ))
            }
        </Grid2>
    )
}

EventsTypeLegendPanel.propTypes = {
    eventsTypes: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
        id: PropTypes.number,
        label: PropTypes.string,
        color: PropTypes.string,
        icon: PropTypes.string,
    })),
}

export default EventsTypeLegendPanel
